module.exports = __webpack_public_path__ + "static/media/INFP.4fb523c8.png";